import * as types from '../actions/actionTypes'

export default function keirinReducer(state = [], action) {
    switch (action.type) {
        case types.keirin.GET_KEIRINSTARTLIST_SUCCESS:
            return { ...state, keirinStartList: action.startlist }

        case types.keirin.GET_KEIRINRESULTS_SUCCESSS:
            return { ...state, keirinResultsList: action.results }


        default:
            return state;
    }
}